import { useCallback, useState } from 'react'
import { useQuery } from 'react-query'

import { SortByType, SortingType } from '@components/Table/interface'
import { useAuthentication } from '@hooks/useAuthentication'
import { useClient } from '@hooks/useClient'
import { TopRankTableProps } from '../TopRankTable/interface'
import { columns } from './columns'
import { MoneySpenderTableProps } from './interface'

export function withMoneySpenderTable(Component: React.FC<TopRankTableProps>) {
  function WithMoneySpenderTable({ searchParam }: MoneySpenderTableProps) {
    const client = useClient()
    const { isAuthenticated } = useAuthentication()
    const [sort, setSort] = useState<SortByType>({
      key: '',
      order: '' as SortingType,
    })

    const handleSort = useCallback(({ key, order }: SortByType) => {
      setSort(prev => ({ ...prev, key, order }))
    }, [])

    const { data = [], isLoading } = useQuery(
      ['money-spender', searchParam, sort],
      () =>
        client?.saleClient.getTopMoneySpender({
          searchParam,
          sort,
        }),
      {
        enabled: isAuthenticated,
      }
    )

    const pageProps = {
      className: 'max-h-[485px] pr-[20px]',
      title: 'Top 20 Money Spender',
      data,
      columns,
      handleSort,
      isLoading,
    }
    return <Component {...pageProps} />
  }

  return WithMoneySpenderTable
}
